export default __webpack_public_path__ + "static/media/BlueNote.ccf645b4.svg";